import script from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"

import "./ArticleGenerator.vue?vue&type=style&index=0&id=7de232db&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de232db"]])

export default __exports__